export default {
      id: "time-usage",
      viewBox: "0 0 34 34",
      url: __webpack_public_path__ + "../../sprite.svg#time-usage",
      toString: function () {
        return this.url;
      }
    }